import { Getters } from 'vuex-smart-module';
import CompaniesUsersState from './state';

export default class OrderGetters extends Getters<CompaniesUsersState> {}
